import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"
import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../../utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
import { Journeys } from "../../../types/Journeys"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

const ALL_JOURNEY_AND_JOURNEY_STAGES_ENDPOINT = "GetAllJourneyAndJourneyStages"

export function useGetAllJourneyAndJourneyStages(): UseQueryResult<Journeys, ResponseError> {
  return useQuery<Journeys, ResponseError>(
    [ALL_JOURNEY_AND_JOURNEY_STAGES_ENDPOINT],
    () => client.getAllJourneyAndJourneyStages(),
    {
      ...RetryConfig
    }
  )
}

const BENEFIT_ENABLED_JOURNEYS_FOR_EMPLOYEE_ENDPOINT = "GetBenefitEnabledJourneysForEmployee"

export function useGetBenefitEnabledJourneysForEmployee(employeeId: number): UseQueryResult<Journeys, ResponseError> {
  return useQuery<Journeys, ResponseError>(
    [BENEFIT_ENABLED_JOURNEYS_FOR_EMPLOYEE_ENDPOINT],
    () => client.getBenefitEnabledJourneysForEmployee(employeeId),
    {
      ...RetryConfig
    }
  )
}
